import { getErrorMessage } from '~/utils/errors'

export const useAuthStore = defineStore('auth', () => {
  const nuxtApp = useNuxtApp()
  const { user, clear: clearUserSession } = useUserSession()

  // Estado reactivo del token
  const byhoursToken = ref<string>(useCookie('byhours_connect').value || '')

  // Función para obtener un token válido (basada en tu getValidByhoursConnect)
  const getValidToken = async (): Promise<string> => {
    const byhoursConnect = useCookie('byhours_connect')
    byhoursToken.value = byhoursConnect.value || ''

    try {
      // Validar el token actual
      await $fetch(`${useBaseUrl()}/user-data`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'User-token': byhoursToken.value || ''
        },
        query: {
          locale: String((nuxtApp.$i18n as { locale: { value: string } }).locale.value)
        }
      })

      return byhoursToken.value
    } catch (error: unknown) {
      console.error('Error al validar el token:', getErrorMessage(error))
      // Si falla, refrescar el token
      try {
        const userEmail = String((user.value as OAuthUser)?.email || '')
        const userPassword = String((user.value as OAuthUser)?.password || '')

        const refreshResponse = await $fetch('/api-web/refresh-token', {
          method: 'POST',
          body: {
            user: {
              email: userEmail,
              password: userPassword
            }
          }
        })

        if (refreshResponse.success && refreshResponse.userToken) {
          byhoursToken.value = refreshResponse.userToken
          byhoursConnect.value = refreshResponse.userToken
          return refreshResponse.userToken
        }

        byhoursToken.value = ''
        byhoursConnect.value = null
        return ''
      } catch (refreshError: unknown) {
        console.error('Error al refrescar el token:', getErrorMessage(refreshError))
        byhoursToken.value = ''
        byhoursConnect.value = null
        return ''
      }
    }
  }

  // Función para obtener headers con el token
  const getAuthHeaders = async () => {
    const token = await getValidToken()
    return {
      'Content-Type': 'application/json',
      ...(token ? { 'User-token': token } : {})
    }
  }

  /**
   * Borra token Byhours, cookie, sesión Nuxt, caché de datos de usuario y checkout en memoria/storage.
   * Usar en logout manual y tras eliminar cuenta.
   */
  async function clearAllUserClientState(): Promise<void> {
    const byhoursConnect = useCookie('byhours_connect')
    byhoursToken.value = ''
    byhoursConnect.value = null
    useCheckoutStore().clearCheckoutData()
    await clearUserSession()
    clearNuxtData([
      'user-data',
      'favorites',
      'active-bookings',
      'past-bookings'
    ])
  }

  /** Token Byhours inválido en API: misma limpieza que logout. */
  async function logoutDueToInvalidUserToken(): Promise<void> {
    await clearAllUserClientState()
  }

  return {
    byhoursToken,
    getValidToken,
    getAuthHeaders,
    clearAllUserClientState,
    logoutDueToInvalidUserToken
  }
}) 